import modalService from '~/@common/services/modal.service'
import Modal from '~/@common/ui/modal/Modal'

import WeeklyCalendarModal from './WeeklyCalendarModal'

const UnavailableDayModal = () => (
  <Modal.Alert
    confirm={{
      onClick: () => modalService.closeModal(),
    }}
  >
    <p style={{ textAlign: 'center' }}>
      학생이 학습을 완료하지 않은
      <br />
      오늘의 학습은 볼 수 없어요!
    </p>
  </Modal.Alert>
)

export const openUnavailableDayModal = () => {
  modalService.openModal(<UnavailableDayModal />, { modalName: 'UnavailableDayModal' })
}

export const openWeeklyCalendarModal = (
  initialWeekStart: Date | null,
  onConfirm: (startDate: Date) => void,
) => {
  modalService.openModal(
    <WeeklyCalendarModal initialWeekStart={initialWeekStart} onConfirm={onConfirm} />,
    { modalName: 'WeeklyCalendarModal', modalStyle: { width: '400px' } },
  )
}
